import _round from 'lodash/round';

import { inMacOS } from '../inMacOS';

interface GetFileSizeInput {
    bytes: number;
    unit: 'KB' | 'MB';
    precision?: number;
}

const baseUnitMac = 1000;
const baseUnitNonMac = 1024;

/**
 * MacOS measures file sizes in Base 10 to match hard drive manufacturers' numbers, but other
 * operating systems use Base 2.
 * https://en.wikipedia.org/wiki/Gigabyte
 * https://support.apple.com/en-us/HT201402
 * @param {GetFileSizeInput} input
 */
export const getFileSize = ({
    bytes,
    unit,
    precision = 1,
}: GetFileSizeInput): number => {
    const baseUnit = inMacOS ? baseUnitMac : baseUnitNonMac;

    let denominator = 1;

    if (unit === 'KB') {
        denominator = baseUnit;
    }

    if (unit === 'MB') {
        denominator = baseUnit * baseUnit;
    }

    const rawSize = bytes / denominator;

    return _round(rawSize, precision);
};
